import Action from "@/action/Action"
import { workflowService } from "@/service"
import InitApplyFlowAction from "@/action/actions/InitApplyFlowAction"
import InitAccountFlowAction from "@/action/actions/InitAccountFlowAction"
import ActionId from "@/action/ActionId"
import FlowType from "@/model/flow/FlowType"

class DelegatingInitFlowAction extends Action {

    #route = null
    #response = null

    constructor(route, response) {
        super("delegatingInitFlowAction")
        this.#route = route
        this.#response = response
    }

    async invoke() {
        const initAction = this.getAction()
        return workflowService.invoke(initAction)
    }

    getAction() {
        switch (this.#response.flowType) {
            case FlowType.CREDIT_LIMIT_CHANGE:
                return new InitAccountFlowAction(ActionId.INIT_CREDIT_LIMIT_CHANGE, this.#route, this.#response)
            default:
                return new InitApplyFlowAction(this.#route, this.#response)
        }
    }
}

export default DelegatingInitFlowAction
